<template>
	<div class="c-workspace">
		<TrialExpiry v-if="isTrialOver"> </TrialExpiry>
		<Box>
			<template v-slot:header>
				<h3>Workspace settings</h3>
			</template>
			<template v-slot:body>
				<template v-if="isWorkspaceAdmin">
					<div class="container-fluid">
						<div class="row">
							<div class="col-md-6">
								<h4>Workspace settings</h4>
								<p>
									Update this section with relevant links and your boards will
									be branded when you share them.
								</p>
							</div>
							<div class="col-md-6">
								<FormWorkspaceUpdate :form="workspace"></FormWorkspaceUpdate>
							</div>
						</div>
					</div>

						<div class="container-fluid">
							<div class="row">
								<div class="col-md-6">
									<h4>Billing settings</h4>
									<p>
										Update your billing settings like VAT code, billing address,
										etc. This will show up in your invoices.
									</p>
								</div>
								<div class="col-md-6">
									<FormBillingUpdate :form="workspace"></FormBillingUpdate>
								</div>
							</div>
						</div>

						<div class="container-fluid">
							<div class="row">
								<div class="col-md-6">
									<h4>Workspace API key</h4>
									<p>
										Use this key for API integrations connected to your workspace.
										If needed, you can regenerate the key anytime.
									</p>
								</div>
								<div class="col-md-6">
									<FormWorkspaceApiKey
										:workspace="workspace"
									></FormWorkspaceApiKey>
								</div>
							</div>
						</div>
					</template>

				<template v-else>
					<p>Only the Workspace Admin can update Workspace settings.</p>
				</template>
			</template>
		</Box>

		<br />
		<br />

		<Box>
			<template v-slot:header>
				<h3>Workspace teammates</h3>
			</template>
			<template v-slot:body>
				<h4>Seats</h4>
				<p>
					Seats can be allocated to users. Add your colleagues, workmates, etc
					and save ads together!
				</p>
				<Seats :workspace="workspace"></Seats>
				<p v-if="isWorkspaceAdmin">
					On your current plan, you can add upto
					{{ workspace.workspaceLimit }} user/s.
				</p>
				<br />
				<h4 v-if="isWorkspaceAdmin">Invite users</h4>
				<FormInviteUsers
					v-if="isWorkspaceAdmin && allowInvite"
				></FormInviteUsers>
				<p v-if="!allowInvite">
					On your current plan, you can only have
					{{ workspace.workspaceLimit }} members in your Workspace.
					<router-link to="/profile/billing"
						>Upgrade to a higher tier</router-link
					>
					to add more teammates.
				</p>
				<br />
			</template>
		</Box>
		<hr />
		<h5>Danger Zone</h5>
		<InputButtonChoice
			:disabled="isDeleteDisabled"
			@input="onDeleteAccount"
			buttonClass="btn-danger"
			label="Permanently delete Account"
		></InputButtonChoice>

		<article class="article-text-sm" v-if="deleteAccountText">
			<p>{{ deleteAccountText }}</p>
		</article>
	</div>
</template>

<script>
import FormWorkspaceUpdate from '@swipekit/components/form/form-workspace-update';
import FormInviteUsers from '@swipekit/components/form/form-invite-users';
import FormBillingUpdate from '@swipekit/components/form/form-billing-update';
import FormWorkspaceApiKey from '@swipekit/components/form/form-workspace-api-key';

import Seats from './seats';
import TrialExpiry from './trial-expiry';
import InputButtonChoice from '@swipekit/components/form/input-button-choice';
import FormSeats from '@swipekit/components/form/form-seats';

import Box from '@swipekit/components/utils/box';

export default {
	components: {
		FormWorkspaceUpdate,
		FormInviteUsers,
		FormBillingUpdate,
		FormWorkspaceApiKey,

		TrialExpiry,
		Seats,
		InputButtonChoice,
		FormSeats,

		Box,
	},

	computed: {
		isDeleteDisabled: function () {
			return false;
			let workspace = this.workspace;

			let user = this.user;

			if (workspace.adminId !== user.id) {
				return true;
			}

			if (workspace.users.length > 1) {
				return true;
			}

			return false;
		},
		deleteAccountText: function () {
			let workspace = this.workspace;

			let user = this.user;

			if (workspace.adminId !== user.id) {
				return `You can't delete your Account. Please contact your Workspace Admin to delete your Account`;
			}

			if (workspace.users.length > 1) {
				return `Please remove all users in your Workspace and ensure you have cancelled your billing before deleting your Account.`;
			}

			return `This will permanently delete your account, your saved Ads & remove you from all transactional / marketing emails.`;
		},
		allowInvite: function () {
			if (!this.workspace) {
				return false;
			}
			let users = [];
			if (this.workspace.users && this.workspace.users.length) {
				users = this.workspace.users.length;
			}

			let workspaceLimit = this.workspace.workspaceLimit;

			if (users >= workspaceLimit) {
				return false;
			} else {
				return true;
			}
		},
		isTrialOver: function () {
			return this.$store.getters['users/isTrialOver'];
		},
		workspace: function () {
			return this.$store.getters['workspaces/all'];
		},
		user: function () {
			return this.$store.getters['users/user'];
		},
		isAdmin: function () {
			return this.$store.getters['users/isAdmin'];
		},
		isWorkspaceAdmin: function () {
			return this.$store.getters['workspaces/isAdmin'];
		},
	},

	methods: {
		onDeleteAccount: function () {
			this.$store.dispatch('message/onAccountDeleted');
			this.$store.dispatch('users/delete').then(() => {
				window.location.reload();
			});
		},
	},
};
</script>

<style lang="scss">
.c-workspace {
	.c-input-button-choice {
		margin: var(--spacer-sm) 0;
	}

	.c-notification {
		padding: var(--spacer-sm);
		margin: var(--spacer) 0;
		margin-top: 0;
		background-color: hsla(var(--s), 80%, 70%, 0.075);

		p:last-child {
			margin-bottom: 0;
		}
	}
}
</style>
